module.exports = __webpack_public_path__ + "img/action-pointer.bc6b6463.png";